import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white">
            <h5 className="text-white">
              <br />
              <br />
            </h5>
          </Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-As Chief Strategy Officer at NBK Egypt, you led a transformation strategy that
                significantly enhanced profitability. What were the key pillars of this
                transformation, and what leadership principles guided its success?
              </strong>
            </h5>

            <h5 className="text-white">
              Strategy is ultimately owned by the CEO. Ultimately, the CSO’s role is to add
              perspective, bring all the different part of the strategy together into a cohesive
              vision, but the execution of the strategy is led by each and every member of the
              leadership team.
              <br />
              <br />
              The key to a successful strategy is its communication, and alignment between the
              different functions that come from different backgrounds and perspectives. The more
              the strategy is communicated and discussed at different levels, the more you uncover
              dissenting voices and the greater the opportunity you have to provide perspective to
              your audience.
              <br />
              <br />
              Our strategy has been to transform into a customer-centric model, with three major
              themes: <br />
              (1) diversification into segments and income pools that are more sustainable and have
              a higher willingness to pay <br />
              (2) operational transformation through more streamlined processes that prioritize
              customer experience, and <br />
              (3) digitization and automation on both the front end which is customer facing and the
              back end, which is operational.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Your leadership has been instrumental in introducing digital solutions that
                streamline operations and improve customer experience. How did you leverage digital
                solutions to drive operational efficiency and enhance customer experience at NBK
                Egypt?
              </strong>
            </h5>
            <h5 className="text-white">
              Our digital transformation has been one of the most challenging elements of our
              strategy. The resistance to the digital direction originally seemed insurmountable.
              Luckily, our digital roadmap was developed by an incredibly talented and unique
              individual in our firm, that speaks three languages: he speaks customer, IT and
              operations. His cross-functional expertise allowed us to bridge a lot of the concerns
              regarding choosing a sub-optimal solution, and made him the perfect person to lead the
              execution of digital projects.
              <br />
              <br />
              When going digital, you have to make decisions that have multiple considerations:
              <br />
              <br />- your current IT architecture; interdependencies with other projects in the
              pipeline; cost; complexity of implementation; and time to market. Execution of our
              digital roadmap has not been as smooth as we originally hoped, but today we are
              implementing lending solutions that have reduced our TAT in secured lending products
              to potentially 15 minutes for straightforward cases. We’ve introduced digital
              solutions at every touchpoint with the customer, but we still have a long way to go.
              We have a great deal in the pipeline.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With extensive experience in investment banking, you have played a crucial role in
                managing landmark IPOs and M&A deals. With your extensive experience in investment
                banking, including landmark IPOs and M&A deals, how has the regional capital markets
                landscape evolved in recent years?
              </strong>
            </h5>
            <h5 className="text-white">
              The biggest change in the landscape has been Saudi. All eyes are on Saudi. The kind of
              growth in interest in Saudi is mind-boggling. Saudi has been home to over 40 IPOs in
              2024, with maybe another 50 expected in 2025. Investors want to invest, contractors
              are seeking projects there, qualified calibers are seeking employment there…everyone
              wants to go to Saudi. We are witnessing a milestone in the history of Saudi Arabia
              with the change in mindset.
              <br />
              <br />
              The second change is that VC money is back. Post-covid, funding directed towards tech
              and fintech dried up. That has changed. We are seeing renewed interest in this segment
              of the market. MENA is a particularly attractive target for tech investors because
              tech is now the only way to bridge the gaps that have been created in MENA economies –
              years of conflict and instability have created a need for reform in education and
              healthcare, and MENA countries with hot and dry weather are at the forefront of the
              climate change crisis.
              <br />
              <br />
              Technology provides one of the few ways for the MENA region to fill these gaps.
              <br />
              <br />
              In Egypt, the most notable trend has been our ability to attract Chinese FDI.
              Deglobalization has led China to seek opportunities in countries with free trade
              agreements to provide them with market access. Egypt is one such market. China has
              built Egypt’s Iconic Tower in the New Administrative Capital. China has invested over
              US$3bn in 170 companies in the Suez Economic Zone, and a total of over US$8bn in Egypt
              as a whole.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Your role on various boards highlights your commitment to corporate governance and
                strategic oversight. Having held several board positions, what are the most critical
                aspects of effective corporate governance in the financial sector?
              </strong>
            </h5>
            <h5 className="text-white">
              Obviously, you want a framework that addresses conflicts of interest and ensures
              transparent reporting. As a Board member, you’re not always given ALL the information
              you need to make an informed decision. This is where your experience comes in handy.
              You have to ask the right questions and request more information. You also have to be
              willing to put in the time to read the documentation.
              <br />
              <br />
              But your job as a Board member isn’t to add an additional layer of bureaucracy. Your
              job is to add value to the strategy of the organization and offer support in key
              decisions. You have to have a sense of perspective and knowledge about what is
              happening in the sector to really add value to the company.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With financial services rapidly evolving, staying ahead of emerging trends is
                critical for competitive advantage. What emerging trends or technologies do you
                believe will have the most significant impact on the financial services sector in
                North Africa in the coming years?
              </strong>
            </h5>
            <h5 className="text-white">
              Obviously AI. Our kids are doing their homework on chatGBT, and there is no telling
              how far AI will take us from how things are done in the workplace as we know it today.
              <br />
              <br />
              There’s a really interesting interview I saw by Mo Gawdat, ex-CEO of Google X, where
              he talks about the rate of AI advancement. Gawdat believes that AI will soon surpass
              human intelligence and ultimately lead the future, and talks about the danger of not
              incorporating ethical considerations into AI development to ensure it benefits
              humanity. I think the same applies to banking. If we don’t incorporate ethical and
              societal considerations into our AI models, we could end up harming our communities
              with performance-driven business models that don’t take societal goals into
              consideration.
              <br />
              <br />I think we are going to see huge investment in techs related to information
              security and regulatory compliance. The kind of existential threats that financial
              organizations, especially banks, face today as a result of attempted attacks on their
              information security warrants that ISO technology works hard to keep up with the risks
              at hand.
              <br />
              <br />
              Scalability with technology will continue to favor mega institutions over smaller
              ones. I think we will continue to see large organizations become larger, and we will
              continue to see consolidation across the sector.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-As a prominent woman leader, your journey serves as an inspiration for aspiring
                women professionals in the financial services industry. As a prominent woman leader
                in finance, what challenges have you faced, and how have you overcome them?
              </strong>
            </h5>
            <h5 className="text-white">
              As a woman, it is a tad bit harder to have people’s ear in the workplace. You get
              interrupted when you speak. Your comments get ignored in large meetings. People talk
              over you. You have to be much more assertive, and take things a lot less personally to
              survive in the workplace.
              <br />
              <br />
              You overcome them by earning people’s respect over time, and by being ok with never
              earning the respect of some due to their inherent biases. And you also learn to choose
              the time and place to speak and argue points. You don’t have to make your point when
              there are 15 executives in a meeting prepared to talk over you. You wait till when you
              really have the floor to speak your mind. You have to choose your battles and continue
              working on your own personal and professional confidence.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Our strategic insights have consistently shaped the institutions you've worked
                with, making you a key thought leader in the region.What is your vision for the
                future of financial services in North Africa, and what role do strategy and
                innovation play in shaping that future?
              </strong>
            </h5>
            <h5 className="text-white">
              The future belongs to organizations that are willing to embrace change and listen to
              the customer. Even strategy and innovation has changed: It used to be that
              organizations would develop a 5-year strategy and stick to it, or that organizations
              would invest in innovation, knowing what the endgame was.
              <br />
              <br />
              Even how strategy is developed has changed. Strategy is now dynamic. The strategic
              goal or theme may not change, but organizations have to continue updating their plan
              on how to get there because the pace of change is unprecedented.
              <br />
              <br />
              The investment in R&D has become a leading indicator on economic health. So innovation
              will continue to dictate market leadership, and will favor larger organizations.
              <br />
              <br />
              Another thing that is shaping the marketplace is the importance of positive feedback.
              Social media is providing what you call a “feedack loop” where a viral post can do
              more good or more harm than millions of dollars spent on marketing or even on customer
              experience. Our awareness of this is making us significantly more responsive to
              customer complaints. I think this is a trend that will continue into the future.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Closing remark- Is there any message you would like to share with the audience at
                Finnovex North Africa 2025 on the importance of strategic leadership, innovation,
                and diversity in driving the future of financial services?
              </strong>
            </h5>
            <h5 className="text-white">
              The last note I want to make is about sustainability in the context of ethical
              business. I hope that the increasing scope of sustainability reporting will lead
              companies in the Middle East and North Africa to start measuring progress, rather than
              only performance metrics. Organizational progress is about adding value to society,
              directly and indirectly. The more organizations adopt a more ethical approach to
              business, the more society will benefit and evolve. Concepts of fairness, diversity,
              equality, environmental responsibility, CSR – all of these should be central to
              organizational strategies leading into the future.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
